import { Children, ComponentProps, PropsWithChildren, ReactNode } from 'react';
import { BoxProps, BoxType, Flex } from 'reflexbox';

export function Join(
	props: PropsWithChildren<BoxProps & { separator: ReactNode; fragment?: boolean }>,
) {
	const { separator, children, ...rest } = props;

	let first = true;

	const result = Children.map(children, (child) => {
		if (!child) {
			return null;
		}

		if (!first) {
			return (
				<>
					{separator}
					{child}
				</>
			);
		} else {
			first = false;

			return child;
		}
	});

	if (props.fragment) {
		return <>{result}</>;
	}

	return <Flex {...(rest as ComponentProps<BoxType>)}>{result}</Flex>;
}
